<div class="bc-top-header-filters flex align-items-center gap-spacing-lg">
  <button
    class="regions-filter relative regions-multiselect"
    type="button"
    #regionsButton
    (click)="openFilters(multiSelectRegions)"
    [ngClass]="{ active: regionsActive() === 'regions' }"
  >
    <div class="flex align-items-center gap-spacing-xs w-full">
      <div class="flex flex-column align-items-start">
        <span class="label label-small-regular">Regions</span>
        @if (selectedRegions.length > 0) {
          <div class="label-large-medium flex align-items-center">
            @if (selectedRegions.length === 1) {
              <div class="value webkit-box-one-line">
                {{ selectedRegions[0].name }}
              </div>
            } @else {
              <div class="value">{{ selectedRegions.length }} Selected</div>
            }
          </div>
        } @else {
          <div class="value white-space-nowrap label-large-medium">
            Select regions
          </div>
        }
      </div>
      <em class="ml-auto ph ph-caret-down"></em>
    </div>
    <p-multiSelect
      #multiSelectRegions
      [options]="regions()"
      (onPanelShow)="regionsActive.set('regions')"
      (onPanelHide)="
        regionsActive.set(null);
        regionsChange(selectedRegions);
        onRegionChange()
      "
      [placeholder]="'Select items'"
      [(ngModel)]="selectedRegions"
      [optionLabel]="'name'"
      [disabled]="false"
      [filter]="true"
      [filterPlaceHolder]="'Search'"
      [appendTo]="regionsButton"
      [virtualScroll]="true"
      [virtualScrollItemSize]="'--px-36' | zCssVarToNumber: 36"
      class="multi-select"
      [styleClass]="'hidden-multiselect'"
      [showClear]="true"
    />
  </button>
  <button
    class="locations-filter relative"
    type="button"
    #locationsButton
    (click)="openFilters(multiSelectLocation)"
    [ngClass]="{ active: locationsActive() === 'locations' }"
  >
    <div class="flex align-items-center gap-2 w-full">
      <div class="flex flex-column align-items-start">
        <span class="label label-small-regular">Locations</span>
        @if (selectedLocations.length > 0) {
          <div class="label-large-medium flex align-items-center">
            @if (selectedLocations.length === 1) {
              <div class="value webkit-box-one-line">
                {{ selectedLocations[0].name }}
              </div>
            } @else {
              <div class="value">{{ selectedLocations.length }} Selected</div>
            }
          </div>
        } @else {
          <div class="value white-space-nowrap label-large-medium">
            Select locations
          </div>
        }
      </div>
      <em class="ml-auto ph ph-caret-down"></em>
    </div>
    <p-multiSelect
      #multiSelectLocation
      (onPanelShow)="locationsActive.set('locations')"
      (onPanelHide)="
        locationsActive.set(null);
        onLocationChange();
        locationsChange(selectedLocations)
      "
      [options]="locations() | locationsFilterPipe: selectedRegions"
      [placeholder]="'Select items'"
      [(ngModel)]="selectedLocations"
      [optionLabel]="'name'"
      [disabled]="false"
      [filter]="true"
      [filterPlaceHolder]="'Search'"
      [appendTo]="locationsButton"
      [virtualScroll]="true"
      [virtualScrollItemSize]="'--px-36' | zCssVarToNumber: 36"
      class="multi-select"
      [styleClass]="'hidden-multiselect'"
    />
  </button>
</div>
